import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_dynamic_email_capture~1
			funnel: {
				id: 'ob-blockers-guide-email',
				locale: ['en'],
			},
		},
	},
]

export default config
